function escapeHtmlAttr(s) {
  if (s == null || s === undefined) return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function escapeHtmlText(s) {
  if (s == null || s === undefined) return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function normalizeImageUrl(value) {
  if (!value) return '';

  if (typeof value === 'string') {
    const v = value.trim();
    // Algolia 側で metafield の参照ID(gid://...)が入る場合は画像URLとして使わない
    if (/^https?:\/\//i.test(v) || /^\/\//.test(v) || /^\//.test(v)) return v;
    return '';
  }

  if (typeof value === 'object') {
    return (
      normalizeImageUrl(value.url) ||
      normalizeImageUrl(value.src) ||
      normalizeImageUrl(value.image?.url) ||
      normalizeImageUrl(value.image?.src) ||
      ''
    );
  }

  return '';
}

class algoliaSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.type = '';
    this.keyword = '';
    this.setQuery();
    this.setInputValue();
    this.binndingEvent();
  }

  getQuery() {
    return new URLSearchParams(location.search);
  }

  setQuery() {
    const query = this.getQuery();
    this.type = query.get('type');
    this.keyword = query.get('q');
  }

  setInputValue() {
    this.keyword &&
      (document.querySelector('.search-form__input').value = this.keyword);
  }

  getInputValue() {
    return document.querySelector('.search-form__input').value;
  }

  search() {
    let searchUrl = `/pages/search?q=${encodeURIComponent(this.getInputValue())}`;
    if (this.type && this.type !== '') {
      searchUrl += `&type=${encodeURIComponent(this.type)}`;
    }
    window.location.href = searchUrl;
  }

  binndingEvent() {
    const self = this;
    document
      .querySelector('.search-form__submit')
      .addEventListener('click', () => {
        self.search();
      });
    document
      .querySelector('.search-form__input')
      .addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          self.search();
        }
      });
  }
}
customElements.define('algolia-search', algoliaSearch);

class algoliaProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.keyword = '';
    this.type = '';
    this.limit = 4;
    this.setQuery();
    this.getProduct();
    this.dispMore();
  }

  escapeKeyword(keyword) {
    return keyword.replace('&', '+%26');
  }

  getQuery() {
    return new URLSearchParams(location.search);
  }

  setQuery() {
    const query = this.getQuery();
    this.keyword = query.get('q');
    this.type = query.get('type');
  }

  setTotal(total) {
    const totalElement = this.querySelector('.collection__total');
    if (!totalElement) return;
    totalElement.innerHTML = `${total} 件`;
  }

  showMoreButton(total) {
    if (this.limit < total) {
      this.querySelector('.showmore-btn').style.display = 'block';
    } else {
      this.querySelector('.showmore-btn').style.display = 'none';
    }
  }

  dispMore() {
    const moreButton = this.querySelector('.showmore-btn');
    moreButton.addEventListener('click', () => {
      this.limit += 4;
      this.getProduct();
    });
  }

  addComma(num) {
    return num.toLocaleString();
  }

  async getAlgoliaSearch() {
    const apiId = 'PDNROFSEND';
    const apiKey = 'b804a6bafa56f14a9186c053d3e23c53';
    const indexName = 'shopify_jmo_products_recently_ordered_count_desc';
    const url = `https://${apiId.toUpperCase()}-dsn.algolia.net/1/indexes/${indexName}/query`;
    const method = 'POST';
    let params = `query=${this.escapeKeyword(this.keyword)}`;
    if (this.limit) params += `&hitsPerPage=${this.limit}`;
    const apiQuery = { params };
    const body = JSON.stringify(apiQuery);
    const apiHeaders = {
      Accept: 'application/json',
      'X-Algolia-Application-Id': apiId,
      'X-Algolia-API-Key': apiKey,
    };

    const response = await fetch(url, { method, headers: apiHeaders, body });
    if (!response || !response.ok) {
      return [false, 0];
    }

    const jsonData = await response.json();
    if (!jsonData || !jsonData.nbHits || !jsonData.hits) {
      return [false, 0];
    }
    return [jsonData.hits, jsonData.nbHits];
  }

  async getProduct() {
    const [products, localTotal] = await this.getAlgoliaSearch();
    this.showMoreButton(localTotal);
    products && this.render(products);
    this.setTotal(localTotal);
  }

  async render(items) {
    let html = '';
    items.map((item) => {
      if ( !item.tags.includes('algolia-ignore') ) {
        html += this.html(item);
      }
    });
    this.querySelector('.collection__items').innerHTML = html;
  }

  html(item) {
    return `<li
    class="collection__item"
    data-ratingvalue="4.7"
    data-ratingcount="3"
    style="display: list-item"
  >
    <div class="product__item  product__item--sold-out">
      <div
        class="collection__item-media lazyloaded"
        data-bg="${item.product_image}"
        style=""
      >
        <img src="${item.product_image}" alt="${item.title}">
      </div>
      <div class="collection__item-content">
        <h6 class="">${item.product_type}</h6>
        <h5>
          <a href=/products/${item.handle}>${item.title}</a>
        </h5>
        <div class="collection__item-tags" />
        <div class="collection__item-variants">
          <p class="product__item-price" />
          <p>
            <span class="collection__item-size"> ${item.variant_title} </span>
            <span class="collection__item-price price__amount">
              <span class="money"> ¥${this.addComma(item.price)} </span>
              <span>税込</span>
            </span>
          </p>
          <p />
        </div>
      </div>
    </div>
  </li>`;
  }
}
customElements.define('algolia-product', algoliaProduct);

class algoliaFaq extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.keyword = '';
    this.type = '';
    this.limit = 5;
    this.setQuery();
    this.getProduct();
    this.dispMore();
  }

  escapeKeyword(keyword) {
    return keyword.replace('&', '+%26');
  }

  getQuery() {
    return new URLSearchParams(location.search);
  }

  setQuery() {
    const query = this.getQuery();
    this.keyword = query.get('q');
    this.type = query.get('type');
  }

  setTotal(total) {
    const totalElement = this.querySelector('.faq__total');
    if (!totalElement) return;
    totalElement.innerHTML = `${total} 件`;
  }

  showMoreButton(total) {
    if (this.limit < total) {
      this.querySelector('.showmore-btn').style.display = 'block';
    } else {
      this.querySelector('.showmore-btn').style.display = 'none';
    }
  }

  dispMore() {
    const moreButton = this.querySelector('.showmore-btn');
    moreButton.addEventListener('click', () => {
      this.limit += 5;
      this.getProduct();
    });
  }

  addComma(num) {
    return num.toLocaleString();
  }

  async getAlgoliaSearch() {
    const apiId = 'PDNROFSEND';
    const apiKey = 'b804a6bafa56f14a9186c053d3e23c53';
    const indexName = 'jmojp_zendesk';
    const url = `https://${apiId.toUpperCase()}-dsn.algolia.net/1/indexes/${indexName}/query`;
    const method = 'POST';
    let params = `query=${this.escapeKeyword(this.keyword)}`;
    if (this.limit) params += `&hitsPerPage=${this.limit}`;
    const apiQuery = { params };
    const body = JSON.stringify(apiQuery);
    const apiHeaders = {
      Accept: 'application/json',
      'X-Algolia-Application-Id': apiId,
      'X-Algolia-API-Key': apiKey,
    };

    const response = await fetch(url, { method, headers: apiHeaders, body });
    if (!response || !response.ok) {
      return [false, 0];
    }

    const jsonData = await response.json();
    if (!jsonData || !jsonData.nbHits || !jsonData.hits) {
      return [false, 0];
    }
    return [jsonData.hits, jsonData.nbHits];
  }

  async getProduct() {
    const [faqs, localTotal] = await this.getAlgoliaSearch();
    this.showMoreButton(localTotal);
    faqs && this.render(faqs);
    this.setTotal(localTotal);
  }

  async render(items) {
    let html = '';
    items.map((item) => {
      html += this.html(item);
    });
    this.querySelector('.list-faq').innerHTML = html;
  }

  html(item) {
    return `<li>
    <a href=https://support.johnmastersorganics.jp/hc/ja/articles/${item.id}>
      <p class="question">${item.title}</p>
      <p class="answer">${item.body_safe}</p>
      <p class="readmore-link">詳しく見る »</p>
    </a>
  </li>`;
  }
}
customElements.define('algolia-faq', algoliaFaq);

function stripCssNoiseFromPlainText(text) {
  if (!text) return '';
  let s = String(text).replace(/\u00a0/g, ' ');
  s = s.replace(/\/\*[\s\S]*?\*\//g, ' ');
  s = s.replace(/(^|[\s;])\/\/[^\n\r]*/gm, '$1 ');

  const removeAtRuleBlock = (src, re) => {
    let out = src;
    let guard = 0;
    while (guard++ < 200) {
      const idx = out.search(re);
      if (idx === -1) break;
      const afterOpen = out.slice(idx).match(re);
      if (!afterOpen) break;
      let i = idx + afterOpen[0].length;
      let depth = 1;
      while (i < out.length && depth > 0) {
        const ch = out[i];
        if (ch === '{') depth += 1;
        else if (ch === '}') depth -= 1;
        i += 1;
      }
      out = out.slice(0, idx) + ' ' + out.slice(i);
    }
    return out;
  };

  s = removeAtRuleBlock(s, /@font-face\s*\{/i);
  s = removeAtRuleBlock(s, /@media[^{]*\{/i);
  s = removeAtRuleBlock(s, /@supports[^{]*\{/i);
  s = s.replace(/@import\s+[^;]+;/gi, ' ');

  let g = 0;
  while (g++ < 500) {
    s = s.replace(/^\s+/, '');
    if (!s) break;
    const first = s[0];
    if (first === '@') break;
    if (/[ぁ-んァ-ヶ一-龠]/.test(first)) break;
    if (!/^#|^\.|^[a-zA-Z_*]/.test(s)) break;

    const brace = s.indexOf('{');
    if (brace === -1) break;
    const sel = s.slice(0, brace);
    if (/[ぁ-んァ-ヶ一-龠]/.test(sel)) break;

    let i = brace + 1;
    let depth = 1;
    while (i < s.length && depth > 0) {
      if (s[i] === '{') depth += 1;
      else if (s[i] === '}') depth -= 1;
      i += 1;
    }
    s = s.slice(i).trim();
  }

  return s.replace(/\s+/g, ' ').trim();
}

function stripAlgoliaBodySnippet(source) {
  if (!source) return '';
  try {
    const doc = new DOMParser().parseFromString(
      `<div class="algolia-snippet-wrap">${source}</div>`,
      'text/html'
    );
    const root = doc.querySelector('.algolia-snippet-wrap');
    if (!root) return '';
    root
      .querySelectorAll('style, script, link, meta, noscript')
      .forEach((el) => el.remove());
    let text = root.innerText || '';
    text = text
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    text = stripCssNoiseFromPlainText(text);
    const firstJa = text.search(/[ぁ-んァ-ヶ一-龠]/);
    if (firstJa > 0) {
      const prefix = text.slice(0, firstJa).replace(/\s+/g, ' ').trim();
      // CSS 断片のような先頭だけ捨てる。英字のブランド名 + 日本語（…は「…）はここで切らない
      const safeLatinOrSpacesLeadIn =
        prefix.length > 0 &&
        /^[A-Za-z0-9\-_.,'&/（）・\s]+$/i.test(prefix) &&
        !/[{};]/.test(prefix);
      if (!safeLatinOrSpacesLeadIn) {
        text = text.slice(firstJa).trim();
      }
    }
    return text;
  } catch (e) {
    return '';
  }
}

class algoliaNews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.keyword = '';
    this.type = '';
    this.limit = 5;
    this.setQuery();
    this.getProduct();
    this.dispMore();
  }

  escapeKeyword(keyword) {
    return keyword.replace('&', '+%26');
  }

  getQuery() {
    return new URLSearchParams(location.search);
  }

  setQuery() {
    const query = this.getQuery();
    this.keyword = query.get('q');
    this.type = query.get('type');
  }

  setTotal(total) {
    const totalElement = this.querySelector('.news__total');
    if (!totalElement) return;
    totalElement.innerHTML = `${total} 件`;
  }

  showMoreButton(total) {
    if (this.limit < total) {
      this.querySelector('.showmore-btn').style.display = 'block';
    } else {
      this.querySelector('.showmore-btn').style.display = 'none';
    }
  }

  dispMore() {
    const moreButton = this.querySelector('.showmore-btn');
    moreButton.addEventListener('click', () => {
      this.limit += 5;
      this.getProduct();
    });
  }

  addComma(num) {
    return num.toLocaleString();
  }

  dateFormat(val) {
    const date = new Date(val);
    return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`;
  }

  getLabel(title) {
    let label = 'OTHERS';
    let color = '#191919';
    if (title === 'Shop News') {
      label = 'SHOP';
      color = '#502C1E';
    } else if (title === 'Online Store News') {
      label = 'ONLINE STORE';
      color = '#857D78';
    }
    return `<strong>
        <em className="bg-store" style="background-color:${color}">
          ${label}
        </em>
      </strong>`;
  }

  getNewsDescription(item) {
    const raw =
      item.body_html_safe || item.body_html || item.cleantext || '';
    return stripAlgoliaBodySnippet(raw);
  }

  getNewsUrl(item) {
    const blogHandle =
      item.blog?.handle ||
      item['blog.handle'] ||
      item.blog_handle ||
      '';
    const articleHandle = item.handle;
    if (!blogHandle || !articleHandle) return '#';
    return `/blogs/${blogHandle}/${articleHandle}`;
  }

  async getAlgoliaSearch() {
    const apiId = 'PDNROFSEND';
    const apiKey = 'b804a6bafa56f14a9186c053d3e23c53';
    const indexName = 'shopify_jmo_articles';
    const url = `https://${apiId.toUpperCase()}-dsn.algolia.net/1/indexes/${indexName}/query`;
    const method = 'POST';
    let params = `query=${this.escapeKeyword(this.keyword)}`;
    if (this.limit) params += `&hitsPerPage=${this.limit}`;
    const apiQuery = { params };
    const body = JSON.stringify(apiQuery);
    const apiHeaders = {
      Accept: 'application/json',
      'X-Algolia-Application-Id': apiId,
      'X-Algolia-API-Key': apiKey,
    };

    const response = await fetch(url, { method, headers: apiHeaders, body });
    if (!response || !response.ok) {
      return [false, 0];
    }

    const jsonData = await response.json();
    if (!jsonData || jsonData.nbHits == null || !Array.isArray(jsonData.hits)) {
      return [false, 0];
    }
    return [jsonData.hits, jsonData.nbHits];
  }

  async getProduct() {
    const [news, localTotal] = await this.getAlgoliaSearch();
    this.showMoreButton(localTotal);
    news && this.render(news);
    this.setTotal(localTotal);
  }

  async render(items) {
    let html = '';
    items.map((item) => {
      const tags = item.tags || [];
      if (!tags.includes('algolia-ignore')) {
        html += this.html(item);
      }
    });
    this.querySelector('.list-news').innerHTML = html;
  }

  html(item) {
    const href = this.getNewsUrl(item);
    const imgSrc = (item.image || '').trim();
    const labelTitle = item.blog?.title || item['blog.title'];
    return `<div class="news-item">
      <a href="${escapeHtmlAttr(href)}">
        <div class="img-news">
          <img src="${escapeHtmlAttr(imgSrc)}" alt="${escapeHtmlAttr(item.title)}" />
        </div>
        <div class="content-news">
          <p class="date-cat">
            <span>${this.dateFormat(item.published_at)}</span>
            ${this.getLabel(labelTitle)}
          </p>
          <p class="title-news">${escapeHtmlText(item.title)}</p>
          <p class="desc-news">${escapeHtmlText(this.getNewsDescription(item))}</p>

          <p class="readmore-news">詳しく見る »</p>
        </div>
      </a>
    </div>`;
  }
}
customElements.define('algolia-news', algoliaNews);

class algoliaSpecial extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.keyword = '';
    this.type = '';
    this.limit = 5;
    this.setQuery();
    this.getProduct();
    this.dispMore();
  }

  escapeKeyword(keyword) {
    return keyword.replace('&', '+%26');
  }

  getQuery() {
    return new URLSearchParams(location.search);
  }

  setQuery() {
    const query = this.getQuery();
    this.keyword = query.get('q');
    this.type = query.get('type');
  }

  setTotal(total) {
    const totalElement = this.querySelector('.special__total');
    if (!totalElement) return;
    totalElement.innerHTML = `${total} 件`;
  }

  showMoreButton(total) {
    if (this.limit < total) {
      this.querySelector('.showmore-btn').style.display = 'block';
    } else {
      this.querySelector('.showmore-btn').style.display = 'none';
    }
  }

  dispMore() {
    const moreButton = this.querySelector('.showmore-btn');
    moreButton.addEventListener('click', () => {
      this.limit += 5;
      this.getProduct();
    });
  }

  addComma(num) {
    return num.toLocaleString();
  }

  dateFormat(val) {
    const date = new Date(val);
    return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`;
  }

  getSpecialImageSrc(item) {
    return (
      normalizeImageUrl(item.image_src) ||
      normalizeImageUrl(item.meta?.thumbnail?.image) ||
      normalizeImageUrl(item['meta.thumbnail.image']) ||
      normalizeImageUrl(item.image) ||
      ''
    );
  }

  getSpecialDescription(item) {
    const raw = item.body_html || item.body_html_safe || item.cleantext || '';
    return stripAlgoliaBodySnippet(raw);
  }

  async getAlgoliaSearch() {
    const apiId = 'PDNROFSEND';
    const apiKey = 'b804a6bafa56f14a9186c053d3e23c53';
    const indexName = 'shopify_jmo_pages';
    const url = `https://${apiId.toUpperCase()}-dsn.algolia.net/1/indexes/${indexName}/query`;
    const method = 'POST';
    let params = `query=${this.escapeKeyword(this.keyword)}`;
    if (this.limit) params += `&hitsPerPage=${this.limit}`;
    const apiQuery = { params };
    const body = JSON.stringify(apiQuery);
    const apiHeaders = {
      Accept: 'application/json',
      'X-Algolia-Application-Id': apiId,
      'X-Algolia-API-Key': apiKey,
    };

    const response = await fetch(url, { method, headers: apiHeaders, body });
    if (!response || !response.ok) {
      return [false, 0];
    }

    const jsonData = await response.json();
    if (!jsonData || !jsonData.nbHits || !jsonData.hits) {
      return [false, 0];
    }
    return [jsonData.hits, jsonData.nbHits];
  }

  async getProduct() {
    const [specials, localTotal] = await this.getAlgoliaSearch();
    this.showMoreButton(localTotal);
    if (specials) {
      this.render(specials);
    }
    this.setTotal(localTotal);
  }

  async render(items) {
    let html = '';
    items.map((item) => {
      html += this.html(item);
    });
    this.querySelector('.list-news').innerHTML = html;
  }

  html(item) {
    const handle = (item.handle || '').trim();
    const pageHref = handle
      ? `/pages/${encodeURIComponent(handle)}`
      : '#';
    const src = (this.getSpecialImageSrc(item) || '').trim();
    const imgBlock = src
      ? `<div class="img-news"><img src="${escapeHtmlAttr(src)}" alt="${escapeHtmlAttr(item.title)}" /></div>`
      : '';
    return `<div class="news-item">
      <a href="${escapeHtmlAttr(pageHref)}">
        ${imgBlock}
        <div class="content-news">
          <p class="title-news">${escapeHtmlText(item.title)}</p>
          <p class="desc-news">${escapeHtmlText(this.getSpecialDescription(item))}</p>
          <p class="readmore-news">詳しく見る »</p>
        </div>
      </a>
    </div>`;
  }
}
customElements.define('algolia-special', algoliaSpecial);
